import React, { useState, useEffect } from "react";
import "./admincontrols.css";
import Loading1 from '../../loading_animation/loading';

const MilestoneManager = () => {
  const [formMode, setFormMode] = useState(null);
  const [year, setYear] = useState("");
  const [allMilestones, setAllMilestones] = useState([]); // store all milestone objects
  const [content, setContent] = useState("");
  const [image, setImage] = useState(null);
  const [existingImage, setExistingImage] = useState(null); // for update preview
  const [message, setMessage] = useState("");
  const [config, setConfig] = useState(null);
  const[isLoading,setIsLoading]=useState(false);

  // Load config.json
  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error("Failed to load config.json:", err));
  }, []);

  // Fetch all milestones for update dropdown
  useEffect(() => {
    const fetchMilestones = async () => {
      if (formMode === "update" && config) {
        try {
          const response = await fetch(`${config.BASE_URL}${config.GET_MILESTONES}`);
          const result = await response.json();
          if (result.success && result.milestones) {
            setAllMilestones(result.milestones);
          } else {
            setAllMilestones([]);
          }
        } catch (error) {
          console.error("Failed to fetch milestones:", error);
        }
      }
    };
    fetchMilestones();
  }, [formMode, config]);

  // When a year is selected, auto-fill details
  useEffect(() => {
    if (formMode === "update" && year) {
      const milestone = allMilestones.find((m) => m.year === year);
      if (milestone) {
        setContent(milestone.content);
        setExistingImage(milestone.image_path);
      } else {
        setContent("");
        setExistingImage(null);
      }
    }
  }, [year, formMode, allMilestones]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!config) return;
      setIsLoading(true);
    const formData = new FormData();
    formData.append("year", year);
    formData.append("content", content);
    if (image) {
      formData.append("image", image);
    }

    try {
      const response = await fetch(
        formMode === "add"
          ? `${config.BASE_URL}${config.ADD_MILESTONE}`
          : `${config.BASE_URL}${config.UPDATE_MILESTONE}`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();
      setIsLoading(false);
      if (result.success) {
        setMessage(result.message);

        // Reset only for add
        if (formMode === "add") {
          setYear("");
          setContent("");
          setImage(null);
          setExistingImage(null);
        }
      } else {
        setMessage(result.message || "Something went wrong");
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error submitting milestone:", error);
      setMessage("Server error, please try again later.");
    }
  };

  return (
    <div className="milestone-container">
      {/* Action buttons */}
      <div className="button-group">
        <button
          onClick={() => {
            setFormMode("add");
            setMessage("");
            setYear("");
            setContent("");
            setImage(null);
            setExistingImage(null);
          }}
          className="btn add-btn"
        >
          Add Milestone
        </button>
        <button
          onClick={() => {
            setFormMode("update");
            setMessage("");
            setYear("");
            setContent("");
            setImage(null);
            setExistingImage(null);
          }}
          className="btn update-btn"
        >
          Update Milestone
        </button>
      </div>

      {/* Conditional Form */}
      {formMode && (
        <form className="milestone-form" onSubmit={handleSubmit}>
          <h2>{formMode === "add" ? "Add Milestone" : "Update Milestone"}</h2>

          {formMode === "add" ? (
            <>
              <label>Year:</label>
              <input
                type="text"
                value={year}
                onChange={(e) => setYear(e.target.value)}
                placeholder="Enter year"
                required
              />
            </>
          ) : (
            <>
              <label>Select Year:</label>
              <select
                value={year}
                onChange={(e) => setYear(e.target.value)}
                required
              >
                <option value="">-- Select Year --</option>
                {allMilestones.map((m) => (
                  <option key={m.year} value={m.year}>
                    {m.year}
                  </option>
                ))}
              </select>
            </>
          )}

          <label>Content:</label>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="Enter milestone content"
            rows="4"
            required
          />

          <label>Image:</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setImage(e.target.files[0])}
          />

          {/* Show existing image only in update mode */}
          {formMode === "update" && existingImage && (
            <div className="image-preview">
              <p>Current Image:</p>
              <img
                src={`/Milestone_images/${existingImage}`}
                alt="Milestone Preview"
                style={{ maxWidth: "200px", marginTop: "10px" }}
              />
            </div>
          )}

          <button type="submit" className="btn submit-btn">
            {formMode === "add" ? "Save Milestone" : "Update Milestone"}
          </button>
        </form>
      )}

      {/* Status message */}
      {message && <p className="status-message">{message}</p>}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}
        >
          <Loading1 />
        </div>
      )}
    </div>
  );
};

export default MilestoneManager;
